<template>
    <v-container fluid class="pl-0">
        <v-row justify="space-between">
            <v-col
                v-for="card in count_alerts"
                :key="card.title"
                md="12"
            >
                <v-card :loading="loading" class="pl-0">
                    <v-img
                        :src="card.src"
                        class="white--text align-end"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        height="61px"
                    >
                        <v-card-title v-text="card.title"></v-card-title>
                    </v-img>

                    <v-card-subtitle class="title text-center">
                        <div v-if="loading">
                            loading...
                        </div>
                        <div v-else>
                            {{ card.count }} alerts
                        </div>
                        </v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: "AlertsCard",
    components: {
    },
    data(){
        return {
            count_alerts: [
                {
                    title: 'ZTF Output stream', 
                    src: 'https://www.ztf.caltech.edu/assets/ZTF-SocialMedia-04de41bd8ff7ed56c54361f28f48509fbbc2ed16c0667eaacb88332018c39d0d.jpg', 
                    flex: 6,
                    count: "-"
                },
                {
                    title: 'ALeRCE Input stream', 
                    src: 'https://www.nlhpc.cl/wp-content/uploads/2020/01/alerce_caso_destacada_01-720x675.jpg', 
                    flex: 6,
                    count: "-"
                },
            ],
            loading: true,
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.$alertsapi.get_alert_count().then(response => {
                this.count_alerts[0].count = response.data.uw;
                this.count_alerts[1].count = response.data.alerce;
                this.loading = false;
            });
        },
    },
}
</script>